/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  BatchUploadRequestUploadPaymentTermDto,
  BatchUploadReviewPaymentTermsPayload,
  BulkStatusUpdatePaymentTermRequest,
  CsvReviewResponseUploadPaymentTermDto,
  PagePaymentTermDtoImpl,
  PaymentTermDtoImpl,
  PaymentTermFilter,
  PaymentTermRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiPaymentTermController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-payment-term-controller
   * @name GetPaymentTerm
   * @request GET:/api/v1/payment-terms/{id}
   */
  getPaymentTerm = (id: string, params: RequestParams = {}) =>
    this.http.request<PaymentTermDtoImpl, any>({
      path: `/v1/payment-terms/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPaymentTermPath = '/v1/payment-terms/${id}'
  static getPaymentTermMethod = 'GET'
  /**
   * No description
   *
   * @tags api-payment-term-controller
   * @name UpdatePaymentTerm
   * @request PUT:/api/v1/payment-terms/{id}
   */
  updatePaymentTerm = (id: string, data: PaymentTermRequest, params: RequestParams = {}) =>
    this.http.request<PaymentTermDtoImpl, any>({
      path: `/v1/payment-terms/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePaymentTermPath = '/v1/payment-terms/${id}'
  static updatePaymentTermMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-payment-term-controller
   * @name DeletePaymentTerm
   * @request DELETE:/api/v1/payment-terms/{id}
   */
  deletePaymentTerm = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/payment-terms/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deletePaymentTermPath = '/v1/payment-terms/${id}'
  static deletePaymentTermMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-payment-term-controller
   * @name BulkStatusUpdatePaymentTerm
   * @request PUT:/api/v1/payment-terms/bulk-status-update
   */
  bulkStatusUpdatePaymentTerm = (
    data: BulkStatusUpdatePaymentTermRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PaymentTermDtoImpl[], any>({
      path: `/v1/payment-terms/bulk-status-update`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkStatusUpdatePaymentTermPath = '/v1/payment-terms/bulk-status-update'
  static bulkStatusUpdatePaymentTermMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-payment-term-controller
   * @name GetPaymentTerms
   * @request GET:/api/v1/payment-terms
   */
  getPaymentTerms = (params: RequestParams = {}) =>
    this.http.request<PaymentTermDtoImpl[], any>({
      path: `/v1/payment-terms`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPaymentTermsPath = '/v1/payment-terms'
  static getPaymentTermsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-payment-term-controller
   * @name CreatePaymentTerm
   * @request POST:/api/v1/payment-terms
   */
  createPaymentTerm = (data: PaymentTermRequest, params: RequestParams = {}) =>
    this.http.request<PaymentTermDtoImpl, any>({
      path: `/v1/payment-terms`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPaymentTermPath = '/v1/payment-terms'
  static createPaymentTermMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-term-controller
   * @name GetPaymentTermsPaged
   * @request POST:/api/v1/payment-terms/paged
   */
  getPaymentTermsPaged = (data: PaymentTermFilter, params: RequestParams = {}) =>
    this.http.request<PagePaymentTermDtoImpl, any>({
      path: `/v1/payment-terms/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getPaymentTermsPagedPath = '/v1/payment-terms/paged'
  static getPaymentTermsPagedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-term-controller
   * @name BatchUploadPaymentTerms
   * @request POST:/api/v1/payment-terms/batch-upload
   */
  batchUploadPaymentTerms = (
    data: BatchUploadRequestUploadPaymentTermDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/payment-terms/batch-upload`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static batchUploadPaymentTermsPath = '/v1/payment-terms/batch-upload'
  static batchUploadPaymentTermsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-term-controller
   * @name BatchUploadReviewPaymentTerms
   * @request POST:/api/v1/payment-terms/batch-upload/review
   */
  batchUploadReviewPaymentTerms = (
    data: BatchUploadReviewPaymentTermsPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<CsvReviewResponseUploadPaymentTermDto, any>({
      path: `/v1/payment-terms/batch-upload/review`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static batchUploadReviewPaymentTermsPath = '/v1/payment-terms/batch-upload/review'
  static batchUploadReviewPaymentTermsMethod = 'POST'
}
